import { ReactNode, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../Redux/reduxCustomHook";
import { RootState } from "../../../Redux/store";
import "./Tabbar.css";
import {
  CompassOutlined,
  SearchOutlined,
  BookOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
import { appZIndex } from "../../../utils/appconst";
import { IAuthType } from "../../../apiservice/authService.type";
import { Device } from "@capacitor/device";

type ITabBar = {
  menuType?: "general" | "vendors" | "users";
};

const Tabbar: React.FC<ITabBar> = ({ menuType = "general" }) => {
  const location = useLocation();
  const [currentUrlPath, setCurrentUrlPath] = useState("");
  const [menu, setMenu] = useState<IMenuType[]>([]);

  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  const navigate = useNavigate();

  const [usePaddedLogic, setUsePaddedLogic] = useState(false);

  type IMenuType = {
    icon: string | any;
    url: string;
    title: string;
    onClick?: () => void;
  };

  const generalMenu: IMenuType[] = [
    {
      icon: <CompassOutlined />, // Icon for Explore
      url: "/users/home",
      title: "Explore",
    },
    {
      icon: <SearchOutlined />, // Icon for Search
      url: "/users/search",
      title: "Search",
    },
    {
      icon: <VideoCameraOutlined />, // Icon for Shorts (you can change this icon if needed)
      url: "/users/shorts",
      title: "Shorts",
    },
    {
      icon: <BookOutlined />, // Icon for Library
      url: "/users/library",
      title: "Library",
    },
    {
      icon: <UserOutlined />, // Icon for Profile
      url: "/users/profile",
      title: "Profile",
      onClick: () => {
        if (authData?.data?.credentials?.email) {
          navigate("/users/profile");
          return;
        }
        showSignInAlert(
          "Login To Your Account",
          "Please Login to your account to have access to this page.",
          "/auth"
        );
      },
    },
  ];

  const usersMenu: IMenuType[] = [
    {
      icon: <CompassOutlined />, // Icon for Explore
      url: "/users/home",
      title: "Explore",
    },
    {
      icon: <SearchOutlined />, // Icon for Search
      url: "/users/search",
      title: "Search",
    },
    {
      icon: <VideoCameraOutlined />, // Icon for Shorts (you can change this icon if needed)
      url: "/users/shorts",
      title: "Shorts",
    },
    {
      icon: <BookOutlined />, // Icon for Library
      url: "/users/library",
      title: "Library",
    },
    {
      icon: <UserOutlined />, // Icon for Profile
      url: "/users/profile",
      title: "Profile",
      onClick: () => {
        if (authData?.data?.credentials?.email) {
          navigate("/users/profile");
          return;
        }
        showSignInAlert(
          "Login To Your Account",
          "Please Login to your account to have access to this page.",
          "/auth"
        );
      },
    },
  ];

  useEffect(() => {
    setCurrentUrlPath(location.pathname);
    updateMenuType();
  }, [location, authData]);

  const updateMenuType = () => {
    // Used Url path to check
    if (menuType === "users") {
      setMenu(usersMenu);
    } else {
      setMenu(generalMenu);
    }
  };

  // Show Sign In Alert
  const showSignInAlert = (title: string, content: ReactNode, url: string) => {
    Modal.confirm({
      title,
      content,
      async onOk() {
        navigate(url);
      },
      onCancel() {
        console.log("Cancelled");
      },
      zIndex: appZIndex.modal,
    });
  };


  useEffect(() => { getDeviceOSVersion(); }, [])


  const getDeviceOSVersion = async () => {
    try {
      const info = await Device.getInfo();
      console.log('Device Information:', info);

      const platform = info.operatingSystem; // e.g., 'ios' or 'android'
      const osApiLevel = info.androidSDKVersion;

      if (platform === "ios") {
        setUsePaddedLogic(true);
      }

      if ((osApiLevel || 0) >= 35) {
        setUsePaddedLogic(true);
      }

    } catch (error) {
      console.error('Error getting device info:', error);
      return null;
    }
  };

  return (
    <>
      <div className={`grid  ${usePaddedLogic ? " tabBarSpaceios  " : " tabBarSpace "}`}>
        &nbsp; <br />
      </div>
      <div className={`${usePaddedLogic ? "  bottomBarios safeAreaBottomios  " : "  bottomBar safeAreaBottom "}    border-t dark:border-t-stone-700   bg-white dark:bg-stone-800 block`}>
        <div className="w3-content">
          <div className="grid">
            <div className="grid grid-flow-col justify-stretch">
              {menu.map((menu: IMenuType, index: number) => (
                <div
                  key={index}
                  className="flex flex-col justify-center items-center h-20 cursor-pointer"
                  onClick={() => {
                    if (menu.onClick) {
                      menu.onClick();
                    } else {
                      navigate(menu.url);
                    }
                  }}
                >
                  <span
                    className={
                      "flex items-center justify-center px-4 py-1 rounded-full transition-colors " +
                      (currentUrlPath === menu.url
                        ? "bg-blue-50 text-blue-800 dark:bg-blue-900/40 dark:text-blue-400"
                        : "text-gray-500 dark:text-stone-400")
                    }
                    style={{ zoom: "1.2" }}
                  >
                    {menu.icon}
                  </span>
                  <span
                    className={
                      "fontAlbertSansRegular text-xs mt-1 " +
                      (currentUrlPath === menu.url
                        ? "text-blue-800 dark:text-blue-400 font-semibold"
                        : "text-gray-500 dark:text-stone-400")
                    }
                  >
                    {menu.title}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tabbar;
